import { prod as auth0Prod } from './auth0.config';
import { Environment } from './environment.d';

export const environment: Environment = {
  production: true,
  apiProjectName: 'embervegez', // a vg-nél '', a többi produkciónál majd a projekt neve
  htmlTitlePrefix: 'Ember végez // ',
  ...auth0Prod,
};
